import { useState } from "react";
import { Moon, Lock } from "lucide-react";
import { MomentShell, SaveButton } from "../day/MomentShell";
import { Chips, Field, inputCls } from "../day/Chips";
import { isCompleted, stepText, modeLabel, STATUS_LABEL } from "./labels";

function ClosedSummary({ e, rec }) {
  const label = e.confirmation_options.find((o) => o.id === rec.evening.confirmation)?.label;
  return (
    <div className="mt-3 space-y-2" data-testid="c2g-evening-closed">
      <p className="a2g-read text-base text-[#E8E4D8]">Esito: <span className="font-semibold">{STATUS_LABEL[rec.status]}</span>{label ? ` («${label}»)` : ""}</p>
      {rec.evening.reflection && <p className="text-sm text-[#B4B4BC]" data-testid="c2g-evening-reflection">La tua riflessione: {rec.evening.reflection}</p>}
      <p className="flex items-center gap-1.5 text-sm text-[#8A8E96]"><Lock size={13} /> Giornata conclusa: non può più essere modificata.</p>
    </div>
  );
}

export function EveningClose({ e, rec, editable, time, onAction }) {
  const selected = !!rec?.selectedStep?.choiceId;
  const closed = !!rec?.evening?.closed;
  const confirmed = selected && isCompleted(rec.status);
  const [outcome, setOutcome] = useState(null);
  const [reflection, setReflection] = useState("");
  const [share, setShare] = useState(false);
  const [saving, setSaving] = useState(false);

  const close = async () => {
    setSaving(true);
    await onAction({ action: "close", outcome: confirmed ? null : outcome, reflection: reflection.trim() || null, share_with_coach: share });
    setSaving(false);
  };

  return (
    <MomentShell icon={Moon} label="Sera" time={time} title={e.title} text={editable && selected && !closed ? e.body : null} done={closed} index={2} testid="c2g-evening">
      {closed ? <ClosedSummary e={e} rec={rec} /> : !selected ? (
        <p className="a2g-read mt-2 text-base text-[#8A8E96]" data-testid="c2g-evening-no-step">La Sera si chiude dopo aver scelto il passo al Mattino.</p>
      ) : !editable ? (
        <p className="a2g-read mt-2 text-base text-[#8A8E96]" data-testid="c2g-evening-pending">La giornata non è stata chiusa: il passo resta in attesa di conferma.</p>
      ) : (
        <>
          <p className="a2g-read mt-3 text-base text-[#B4B4BC]">Il tuo passo{modeLabel(rec) ? ` (${modeLabel(rec)})` : ""}: <span className="font-medium text-[#F4F4F5]">{stepText(rec)}</span></p>
          {confirmed ? (
            <p className="mt-2 text-base text-[#10B981]" data-testid="c2g-evening-already-confirmed">Hai già confermato il passo a Mezzogiorno: ora chiudi la giornata.</p>
          ) : (
            <Field label={e.confirmation_question}>
              <Chips options={e.confirmation_options.map((o) => ({ value: o.id, label: o.label }))} value={outcome} onChange={setOutcome} testid="c2g-evening-outcome" />
            </Field>
          )}
          <Field label="Domanda del giorno (risposta facoltativa)">
            <p className="a2g-read mt-1 text-base text-[#F4F4F5]" data-testid="c2g-reflection-question">{e.reflection_question}</p>
            <textarea value={reflection} onChange={(ev) => setReflection(ev.target.value)} rows={3} maxLength={2000} placeholder="Scrivi qui, se vuoi…" className={`${inputCls} resize-none`} data-testid="c2g-reflection-input" />
          </Field>
          <label className="mt-4 flex cursor-pointer items-center gap-3 text-sm text-[#B4B4BC]">
            <input type="checkbox" checked={share} onChange={(ev) => setShare(ev.target.checked)} className="h-4 w-4 accent-[#D4AF37]" data-testid="c2g-share-coach" />
            Coach Mino può leggere la mia riflessione
          </label>
          <p className="mt-3 text-sm text-[#8A8E96]">Dopo la chiusura la giornata non sarà più modificabile.</p>
          <SaveButton onClick={close} disabled={!confirmed && !outcome} saving={saving} label="Chiudi la giornata" testid="c2g-close-button" />
        </>
      )}
    </MomentShell>
  );
}
